
import React, { useState } from 'react';
import { Row, Col, Card, CardTitle, CardSubtitle, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Components
import TextField from '../../../../components/TextField';

//Api
import usuario_api from '../../../../api/usuario_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';

//context
import { useAuth } from '../../../../context/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

function initialStateRecuperarSenha() {
    return {
        email: "",
        documentoPessoal: ""
    }
}
export default function EsqueceuSenhaMunicipe({ btnVoltar }) {
    const navigate = useNavigate();
    const { setLoading } = useAuth();

    //Estado de recuperação de senha
    const [recuperarSenha, setRecuperarSenha] = useState(initialStateRecuperarSenha);

    //Função de onChange dos campos da tela inicial
    const onChange = (e) => {
        const { name, value } = e.target;
        setRecuperarSenha({
            ...recuperarSenha,
            [name]: value
        });
    }

    //Função de envio dos dados 
    const onSubmit = () => {
        setLoading(true);
        usuario_api.esqueceuSenhaMunicipe(recuperarSenha).then(response => {
            showMessage("Sucesso", "E-mail de recuperação enviado com sucesso!", "success", btnVoltar);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    return (
        <div className='mainContainerLogin'>
            <div style={{ marginTop: "10vh" }} className='w-75 d-flex align-items-center justify-content-start mb-4'>
                <Button onClick={btnVoltar}>
                    <FontAwesomeIcon icon={faAngleLeft} />  Voltar
                </Button>
            </div>
            <Card className='w-75' style={{ border: "none", padding: "1rem" }}>
                <Row className='p-4'>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center' style={{ borderRight: "1px solid #ccc" }}>
                        <div className="mb-3">
                            <img src={require('../../../../assets/img/logo.png')} className='img-logo' alt="logo do sistema GAIA" />
                        </div>
                        <CardTitle tag={'h4'} style={{ color: "#666" }} className='mb-2 font-weight-normal'>Seja bem vindo ao GAIA </CardTitle>
                        <CardSubtitle tag="p" style={{ color: "#ccc", fontSize: '16pt' }} className='mb-2'>
                            Sistema de Gestão Arbórea
                        </CardSubtitle>
                    </Col>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-around '>
                        <CardTitle tag={'h4'} className=' text-center' style={{ color: "#666" }}>E-mail para recuperação</CardTitle>
                        <Row>
                            <Col md="12" lg="12">
                                <TextField label={"E-mail"} onChange={onChange} value={recuperarSenha.email} name={"email"} />
                            </Col>
                            <Col md="12" lg="12">
                                <TextField mask={mascaras.cpfcnpjMask} label={"CPF/CNPJ"} onChange={onChange} value={recuperarSenha.documentoPessoal} name={"documentoPessoal"} />
                            </Col>
                        </Row>
                        <div>
                            <Button color='success' style={{ width: "80%" }} onClick={onSubmit}>
                                Entrar
                            </Button>
                        </div>
                    </Col>

                </Row>
            </Card>
        </div>
    )
}